// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"131":"34cd95b4","174":"502e8a07","580":"34fceec6","857":"40eec79a","961":"336b1ad0"}[chunkId] + ".js";
};